import { useCallback } from 'react';
import { useAppLocale } from '../../app/locale/AppIntlProvider';
import { withPreviewLang } from './previewPageLang';

/** Adds the app language to the address of a SmartLink page that the app previews or opens. */
export function usePreviewPageLang(): (address: string) => string {
  const { locale } = useAppLocale();
  return useCallback((address: string) => withPreviewLang(address, locale), [locale]);
}
